/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { GetDocumentContactsResponseDataFromJSON, GetDocumentContactsResponseDataToJSON } from './GetDocumentContactsResponseData';
export function GetDocumentContactsResponseFromJSON(json) {
    return GetDocumentContactsResponseFromJSONTyped(json, false);
}
export function GetDocumentContactsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        status: !exists(json, 'status') ? undefined : json['status'],
        data: !exists(json, 'data') ? undefined : GetDocumentContactsResponseDataFromJSON(json['data'])
    };
}
export function GetDocumentContactsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        status: value.status,
        data: GetDocumentContactsResponseDataToJSON(value.data)
    };
}
